var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 167,
    height: 97,
    viewBox: "0 0 167 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3239",
    "data-name": "Rectangle 3239",
    width: 167,
    height: 97,
    transform: "translate(0 0.135)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10944",
    "data-name": "Group 10944",
    transform: "translate(0 -0.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10939",
    "data-name": "Group 10939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10938",
    "data-name": "Group 10938",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29508",
    "data-name": "Path 29508",
    d: "M43.3,22.023,12.363,9.484a4.215,4.215,0,0,1,2.394-8.048l32.2,6.314Z",
    transform: "translate(12.735 1.773)",
    fill: "#737ec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29509",
    "data-name": "Path 29509",
    d: "M55.307,34.34,20.762,38.75V12.179A9.78,9.78,0,0,1,38.938,7.13Z",
    transform: "translate(27.255 3.106)",
    fill: "#b3d2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29510",
    "data-name": "Path 29510",
    d: "M23.012,11.923V20.6A1.735,1.735,0,0,0,25,22.331l16.08-2.042a1.734,1.734,0,0,0,1.3-2.674l-3.939-6.559a1.743,1.743,0,0,0-1.529-.849H24.772a1.754,1.754,0,0,0-1.237.488,1.721,1.721,0,0,0-.523,1.228",
    transform: "translate(30.209 13.399)",
    fill: "#dbebff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29511",
    "data-name": "Path 29511",
    d: "M87.251,15.891V24.03L4.517,34.645A4.588,4.588,0,0,0,.523,39.171V30.986A4.581,4.581,0,0,1,4.517,26.46Z",
    transform: "translate(0.687 20.861)",
    fill: "#737ec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29512",
    "data-name": "Path 29512",
    d: "M11.641,25.4a4.038,4.038,0,0,0,4.542,3.939l31.53-4.02a4.041,4.041,0,0,0-1.02-8.014L15.163,21.4a4.038,4.038,0,0,0-3.522,4",
    transform: "translate(15.282 22.696)",
    fill: "#8293e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29513",
    "data-name": "Path 29513",
    d: "M35.012,18.493v4.218A1.957,1.957,0,0,0,37.3,24.635l4.769-.606V15.891l-5.2.678a1.933,1.933,0,0,0-1.85,1.924",
    transform: "translate(45.962 20.861)",
    fill: "#5a56b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29514",
    "data-name": "Path 29514",
    d: "M4.526,30.025,87.26,19.41V45.22a5.7,5.7,0,0,1-5.7,5.62H5.077A4.567,4.567,0,0,1,.516,46.351V34.5a4.562,4.562,0,0,1,4.01-4.473",
    transform: "translate(0.677 25.48)",
    fill: "#9bb0e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29515",
    "data-name": "Path 29515",
    d: "M87.26,29.812v1.735a5.685,5.685,0,0,1-5.7,5.638H5.077A4.567,4.567,0,0,1,.516,32.7V29.812Z",
    transform: "translate(0.677 39.135)",
    fill: "#7d97e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29516",
    "data-name": "Path 29516",
    d: "M56.195,44.409H17.7L25.84,27.651a5.909,5.909,0,0,1,5.322-3.342H51.976a4.252,4.252,0,0,1,4.237,4.228Z",
    transform: "translate(23.234 31.911)",
    fill: "#5f6ab1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29517",
    "data-name": "Path 29517",
    d: "M104.234,35.414l-19.91-2.322a3.118,3.118,0,0,1-2.639-2.322L75.163,4.851A4.98,4.98,0,0,0,70.32,1.074H42.993a4.959,4.959,0,0,0-4.97,4.961V70.024a4.967,4.967,0,0,0,4.97,4.887h63.672A3.933,3.933,0,0,0,110.6,70.8L109.2,40.744a5.622,5.622,0,0,0-4.961-5.331",
    transform: "translate(49.914 1.41)",
    fill: "#619aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29518",
    "data-name": "Path 29518",
    d: "M38.023,32.748a4.967,4.967,0,0,0,4.97,4.887h63.672a3.933,3.933,0,0,0,3.939-4.11l-.19-4.057H41.222a3.179,3.179,0,0,0-2.294.967,3.223,3.223,0,0,0-.9,2.313",
    transform: "translate(49.914 38.685)",
    fill: "#576df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29519",
    "data-name": "Path 29519",
    d: "M80.4,28.312l-.28-6.071a3.208,3.208,0,0,0-2.81-3.018L59.582,17.171a2.8,2.8,0,0,0-3.226,2.711V28.43a2.747,2.747,0,0,0,2.791,2.845H77.568a2.786,2.786,0,0,0,2.079-.858,2.747,2.747,0,0,0,.749-2.1",
    transform: "translate(73.979 22.497)",
    fill: "#7ab8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29520",
    "data-name": "Path 29520",
    d: "M65.459,5.27a1.737,1.737,0,0,0-1.735-1.355h-20.9a1.735,1.735,0,0,0-1.735,1.735v54.6a2.855,2.855,0,0,0,2.872,2.865H55.1a2.8,2.8,0,0,0,2.586-1.735A24.221,24.221,0,0,1,69.055,49.609,2.837,2.837,0,0,0,70.6,47.07c-.074-25.648.83-18.213-5.141-41.8",
    transform: "translate(53.946 5.138)",
    fill: "#5a56b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29521",
    "data-name": "Path 29521",
    d: "M50.342,30.038c4.762-5.359,6.631-4.889,6.631-6.54V21.763a1.531,1.531,0,0,0-1.526-1.529H46.341a1.544,1.544,0,0,0-1.529,1.529V29.08a1.522,1.522,0,0,0,1.529,1.508c3.125-.046,3.432.09,4-.55",
    transform: "translate(58.827 26.562)",
    fill: "#5a74cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29522",
    "data-name": "Path 29522",
    d: "M69.848,22.852c-.641-2.775-1.735-7.165-4.39-17.572a1.736,1.736,0,0,0-1.735-1.374h-20.9a1.735,1.735,0,0,0-1.735,1.735V24.1a3.24,3.24,0,0,0,3.242,3.242H66.173a3.758,3.758,0,0,0,2.9-1.374,3.8,3.8,0,0,0,.777-3.115",
    transform: "translate(53.946 5.127)",
    fill: "#d1ebf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29523",
    "data-name": "Path 29523",
    d: "M58.111,11.5a1.1,1.1,0,0,0,.867-.423,1.121,1.121,0,0,0,.19-.951l-.506-2.04a2.61,2.61,0,0,0-2.53-1.961h-10.2a2.619,2.619,0,0,0-2.62,2.6v1.735a1.116,1.116,0,0,0,1.094,1.094Zm1.247,2.475H44.406a1.114,1.114,0,0,0-1.094,1.112V16.6a2.634,2.634,0,0,0,2.62,2.62H58.074a2.587,2.587,0,0,0,2.051-1,2.62,2.62,0,0,0,.479-2.239c-.1-.363-.19-.742-.289-1.156a1.131,1.131,0,0,0-.957-.842",
    transform: "translate(56.857 8.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29524",
    "data-name": "Path 29524",
    d: "M40.257,43.014A17.59,17.59,0,1,1,22.669,25.426,17.594,17.594,0,0,1,40.257,43.014",
    transform: "translate(6.666 33.378)",
    fill: "#464669"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29525",
    "data-name": "Path 29525",
    d: "M16.536,43.63a6.787,6.787,0,1,1,4.787-2.014,6.759,6.759,0,0,1-4.787,2.014",
    transform: "translate(12.799 39.52)",
    fill: "#737ec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29526",
    "data-name": "Path 29526",
    d: "M85.322,43.014A17.588,17.588,0,1,1,67.733,25.426,17.594,17.594,0,0,1,85.322,43.014",
    transform: "translate(65.827 33.378)",
    fill: "#464669"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29527",
    "data-name": "Path 29527",
    d: "M61.591,43.63A6.771,6.771,0,1,1,66.4,41.625a6.764,6.764,0,0,1-4.806,2.005",
    transform: "translate(71.97 39.52)",
    fill: "#737ec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29528",
    "data-name": "Path 29528",
    d: "M68.183,29.512H75.5a2.826,2.826,0,0,1,2.828,2.826v2.486A2.826,2.826,0,0,1,75.5,37.651H68.183a2.826,2.826,0,0,1-2.828-2.826V32.338a2.826,2.826,0,0,1,2.828-2.826",
    transform: "translate(85.794 38.742)",
    fill: "#d1ebf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29529",
    "data-name": "Path 29529",
    d: "M31.843,9.526a4.3,4.3,0,1,1-4.3-4.3,4.306,4.306,0,0,1,4.3,4.3",
    transform: "translate(30.511 6.862)",
    fill: "#737ec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29530",
    "data-name": "Path 29530",
    d: "M14.916,12.427a3.488,3.488,0,1,1-3.488-3.478,3.484,3.484,0,0,1,3.488,3.478",
    transform: "translate(10.424 11.748)",
    fill: "#737ec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29531",
    "data-name": "Path 29531",
    d: "M58.32,1.074h5.2a3.464,3.464,0,0,1,3.469,3.469v8.222a3.02,3.02,0,0,1-3.053,3H61.963a3.622,3.622,0,0,1-3.624-3.624V1.074Z",
    transform: "translate(76.559 1.41)",
    fill: "#619aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29532",
    "data-name": "Path 29532",
    d: "M112.123,52.444a4.54,4.54,0,0,0,2.512-4.091c0-25.1.9-18.819-4.905-41.629a4.343,4.343,0,0,0-.678-1.871,3.478,3.478,0,0,0-2.944-1.6H85.2a3.47,3.47,0,0,0-3.469,3.469V61.47a4.6,4.6,0,0,0,4.6,4.6H97.461a4.573,4.573,0,0,0,4.131-2.692,22.551,22.551,0,0,1,10.532-10.932M106.189,6.832c.83,3.36,4.336,17.137,4.336,17.57a2,2,0,0,1-.407,1.663,2.023,2.023,0,0,1-1.554.749H86.711a1.475,1.475,0,0,1-1.473-1.427V6.776ZM98.418,61.958a1.065,1.065,0,0,1-1,.641H86.276a1.13,1.13,0,0,1-1.129-1.129V30.059c1.112.308-.414.224,23.417.224a5.212,5.212,0,0,0,2.549-.659V48.353a1.083,1.083,0,0,1-.569.994A25.835,25.835,0,0,0,98.418,61.958M17.764,63.964a8.5,8.5,0,1,0,8.5,8.5,8.5,8.5,0,0,0-8.5-8.5m0,13.532a5.031,5.031,0,1,1,5.03-5.03,5.025,5.025,0,0,1-5.03,5.03M122.008,63.964a8.5,8.5,0,1,0,8.483,8.5,8.506,8.506,0,0,0-8.483-8.5m0,13.532a5.033,5.033,0,1,1,5.014-5.03,5.041,5.041,0,0,1-5.014,5.03",
    transform: "translate(12.159 4.272)",
    fill: "#302d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10941",
    "data-name": "Group 10941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10940",
    "data-name": "Group 10940",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29533",
    "data-name": "Path 29533",
    d: "M50.219,16.086H45.161a1.735,1.735,0,0,0,0,3.469h5.058a1.735,1.735,0,0,0,0-3.469",
    transform: "translate(57.007 21.117)",
    fill: "#302d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29534",
    "data-name": "Path 29534",
    d: "M162.579,66.306c-1.112-23.9,0-1.383-1.147-24.492a7.337,7.337,0,0,0-6.506-6.938l-19.892-2.359a1.4,1.4,0,0,1-1.156-1.02c-7.119-28.322-6.54-26.435-7.146-27.545h6.938v9.313a5.351,5.351,0,0,0,5.437,5.375h1.933a4.752,4.752,0,0,0,4.753-4.75V5.669a5.206,5.206,0,0,0-5.2-5.2H93.495a6.724,6.724,0,0,0-6.767,6.712V34.93l-2.738.345L68.2,9.038a11.489,11.489,0,0,0-16.73-3.3l-23.056-4.5a5.935,5.935,0,0,0-4.824,10.5l-2.431,7.109a5.207,5.207,0,0,0,1.284,10.308,2.81,2.81,0,1,1-2.835,2.81,1.735,1.735,0,0,0-1.735-1.735c-3.469,0-1.51,8,4.526,8a6.262,6.262,0,0,0,4.11-11.085A5.069,5.069,0,0,0,24.79,19.2l1.943-5.934c2.04.849-7.41-2.981,20.137,8.166V40.061l-41.324,5.2A6.309,6.309,0,0,0,0,51.579V71.563a6.3,6.3,0,0,0,6.279,6.3h4.336a19.325,19.325,0,0,0,38.493,0H82.752a7.446,7.446,0,0,0,5.5-2.431,6.782,6.782,0,0,0,5.2,2.431h21.458a19.307,19.307,0,0,0,38.475,0h8.529a4.552,4.552,0,0,0,4.6-4.563V70.823a4.57,4.57,0,0,0-3.939-4.517M142.324,5.6v8.219a1.279,1.279,0,0,1-1.284,1.293h-1.933a1.9,1.9,0,0,1-1.887-1.843V3.934h3.469a1.733,1.733,0,0,1,1.635,1.735ZM22.441,25.669a1.735,1.735,0,1,1,1.735-1.735,1.735,1.735,0,0,1-1.735,1.735M26.525,9.455a2.5,2.5,0,0,1,.759-4.861c.333,0-1-.227,21.455,4.184C46.606,12,46.833,14.811,46.833,17.72ZM50.3,15a8.069,8.069,0,0,1,14.97-4.165L80.3,35.815,50.3,39.6ZM3.469,51.579a2.833,2.833,0,0,1,2.465-2.808l80.793-10.3V43.1c-87.2,11.14-81.785,10.292-83.259,11Zm26.453,40.4A15.855,15.855,0,1,1,45.776,76.126,15.857,15.857,0,0,1,29.922,91.98M49.174,74.392a19.685,19.685,0,0,0-1.735-6.434l3.8-7.859A4.149,4.149,0,0,1,55,57.74H75.814a2.5,2.5,0,0,1,2.5,2.477V74.355Zm33.65,0H81.751V60.252a5.954,5.954,0,0,0-5.972-5.944H54.965a7.635,7.635,0,0,0-6.938,4.3l-2.757,5.81a19.3,19.3,0,0,0-34.582,9.975H6.351a2.828,2.828,0,0,1-2.042-.8,2.8,2.8,0,0,1-.84-2.024V59.72a2.729,2.729,0,0,1,.7-1.862,2.406,2.406,0,0,1,.55-.5C5.53,56.8.4,57.615,86.709,46.6v23.9a3.976,3.976,0,0,1-3.885,3.885M90.2,71.166V7.177a3.249,3.249,0,0,1,3.226-3.242h27.355A3.2,3.2,0,0,1,123.912,6.4l6.6,25.947a4.849,4.849,0,0,0,4.128,3.622l19.91,2.313a3.873,3.873,0,0,1,3.469,3.7s.245,5.3.264,5.322c-1.735-1-.506-.641-22.549-3.226a1.747,1.747,0,1,0-.416,3.469l19.91,2.322a4.118,4.118,0,0,1,3.351,3.957c0,.171-.09-1.735.569,12.459h-4.579a4.453,4.453,0,0,0-3.118,1.247,19.322,19.322,0,0,0-36.532,6.938H93.495a3.239,3.239,0,0,1-3.3-3.3M134.1,91.98a15.8,15.8,0,1,1,.065,0ZM163.048,73.3a1.1,1.1,0,0,1-1.057,1.094h-7.426a1.092,1.092,0,0,1-1.094-1.094V70.823a1.092,1.092,0,0,1,1.094-1.094h7.355a1.084,1.084,0,0,1,1.057,1.094Z",
    transform: "translate(0 0.61)",
    fill: "#302d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10943",
    "data-name": "Group 10943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10942",
    "data-name": "Group 10942",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29535",
    "data-name": "Path 29535",
    d: "M39.851,58.854H28.008a1.735,1.735,0,1,0,0,3.469H39.851a1.735,1.735,0,1,0,0-3.469M27.122,4.893a6.007,6.007,0,0,0-1.735,10.759,6.145,6.145,0,0,0,3.388,1.022A6.019,6.019,0,1,0,27.041,4.893ZM29.848,13a2.561,2.561,0,1,1,1.013-3.478A2.563,2.563,0,0,1,29.848,13",
    transform: "translate(29.857 6.083)",
    fill: "#302d3d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarsIcon);
export default __webpack_public_path__ + "static/media/cars_icon.37714616bed69d8380f4d5be426ff2af.svg";
export { ForwardRef as ReactComponent };